import { ThunkAction as ThunkActionCreator } from 'redux-thunk';
import { AnyAction } from 'redux';
import { SnackbarKey } from 'notistack';
import { AppStore, INotification, Store } from '../types';

export enum ActionType {
    SET_USER = 'SET_USER',
    SET_PRODUCT_CATEGORIES = 'SET_PRODUCT_CATEGORIES',
    SET_PRODUCTS = 'SET_PRODUCTS',
    REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION',
    ENQUEUE_NOTIFICATION = 'ENQUEUE_NOTIFICATION',
    SET_CATEGORY_IMAGES = 'SET_CATEGORY_IMAGES',
    SET_TABLES = 'SET_TABLES',
    SET_STORE_CONFIGURATION = 'SET_STORE_CONFIGURATION',
    SET_AVAILABLE_LANGUAGES = 'SET_AVAILABLE_LANGUAGES',
    SET_USERS = 'SET_USERS',
    SET_LOADING = 'SET_LOADING',
    SET_CLOSURES = 'SET_CLOSURES'
}

interface SetLoading {
    type: ActionType.SET_LOADING;
    payload: AppStore['loading'];
}

interface SetUser {
    type: ActionType.SET_USER;
    payload: AppStore['user'];
}

interface SetProductCategories {
    type: ActionType.SET_PRODUCT_CATEGORIES;
    payload: AppStore['productCategories'];
}

interface CloseNotification {
    type: ActionType.REMOVE_NOTIFICATION;
    payload: SnackbarKey;
}

interface EnqueueNotification {
    type: ActionType.ENQUEUE_NOTIFICATION;
    payload: INotification;
}

interface SetCategoryImages {
    type: ActionType.SET_CATEGORY_IMAGES;
    payload: AppStore['categoryImages'];
}

interface SetTables {
    type: ActionType.SET_TABLES;
    payload: AppStore['tables'];
}

interface SetStoreConfiguration {
    type: ActionType.SET_STORE_CONFIGURATION;
    payload: AppStore['storeConfiguration'];
}

interface SetAvailableLanguages {
    type: ActionType.SET_AVAILABLE_LANGUAGES;
    payload: AppStore['availableLanguages'];
}

interface SetProducts {
    type: ActionType.SET_PRODUCTS;
    payload: AppStore['products'];
}

interface SetUsers {
    type: ActionType.SET_USERS;
    payload: AppStore['users'];
}

interface SetClosures {
    type: ActionType.SET_CLOSURES;
    payload: AppStore['closures'];
}

export type Action =
    | SetUser
    | SetProductCategories
    | CloseNotification
    | EnqueueNotification
    | SetCategoryImages
    | SetTables
    | SetStoreConfiguration
    | SetAvailableLanguages
    | SetProducts
    | SetUsers
    | SetLoading
    | SetClosures;

export type ThunkAction<R = void> = ThunkActionCreator<R, Store, unknown, AnyAction>;
